import { ACCESSIBLE_MUDULE_KEYS } from "../../constants/enum"
import { ISidebarMenuItem } from "../../layout/FullLayout/sidebar/Siderbar.types"
import { User } from "lucide-react"


export const UBER_EATS_ROUTE = "/uber-eats"
export const UBER_EATS_ORDER_NOTIFICATIONS_ROUTE = UBER_EATS_ROUTE + "/order-notifications"

export const UBER_EATS_NEW_ORDERS_ROUTE = UBER_EATS_ROUTE + "/new-orders"
export const UBER_EATS_IN_PROGRESS_ORDERS_ROUTE = UBER_EATS_ROUTE + "/in-progress-orders"
export const UBER_EATS_ORDER_READY_FOR_PICKUP_ROUTE = UBER_EATS_ROUTE + "/ready-for-pickup"
export const UBER_EATS_ORDER_HISTORY_ROUTE = UBER_EATS_ROUTE + "/orders-history"



export const uberEatsMenu: ISidebarMenuItem = {
  title: "Uber Eats",
  icon: User,
  href: UBER_EATS_ROUTE,
  accessibleModules: [ACCESSIBLE_MUDULE_KEYS.UBER_EATS],
  children: [
    {
      title: "New Orders",
      icon: User,
      href: UBER_EATS_NEW_ORDERS_ROUTE,
      accessibleModules: [ACCESSIBLE_MUDULE_KEYS.UBER_EATS],
    },
    {
      title: "In Progress",
      icon: User,
      href: UBER_EATS_IN_PROGRESS_ORDERS_ROUTE,
      accessibleModules: [ACCESSIBLE_MUDULE_KEYS.UBER_EATS],
    },
    {
      title: "Ready For Pickup",
      icon: User,
      href: UBER_EATS_ORDER_READY_FOR_PICKUP_ROUTE,
      accessibleModules: [ACCESSIBLE_MUDULE_KEYS.UBER_EATS],
    },
    {
      title: "Order History",
      icon: User,
      href: UBER_EATS_ORDER_HISTORY_ROUTE,
      accessibleModules: [ACCESSIBLE_MUDULE_KEYS.UBER_EATS],
    },
  ]
}